import { useDisclosure } from '@chakra-ui/react'
import { createMetaStore } from './meta'

const [FilterDisclosureProvider, useFilterDisclosure] = createMetaStore(() => useDisclosure())

export {
  FilterDisclosureProvider,
  useFilterDisclosure,
}
